export class symbolLookup {
    symbolInputElementId;
    setInitialFocus = false;
    objectName;
    callbackFunction;
    symbolListElementId = "";  // Optional. Set to the element id of the symbol list element if you plan to call addSymbolToList().
    useBSSymbolLookup = false;  // Set to true if the symbol list element is styled with Bootstrap 5.
    disabled = false;

    // Constructor parameters:
    // inputElementId: Id of the symbol text input field.
    // initialFocus: True to make this field have focus when page loads.
    // objName: The name of the object created with this class as a string.
    // callFunction: A callback function to call when the symbol changes.
    constructor(inputElementId, initialFocus, objName, callFunction) {
        this.symbolInputElementId = inputElementId;
        this.setInitialFocus = initialFocus;
        this.objectName = objName;
        this.callbackFunction = callFunction;

        const classContext = this;

        // Setup autocomplete.
        $(`#${this.symbolInputElementId}`).autocomplete({
            minLength: 0,
            source: "/ajax/symbol.php?format=json&limit=10",
            focus: function (event, ui) {
                //Take out for now.
                //$(event.target).val(ui.item.symbol);
                return false;
            },
            select: function (event, ui) {
                $(event.target).val(ui.item.symbol);
                event.target.select();
                classContext.callbackFunction(ui.item.symbol);
                //$("#selected-company").html(ui.item.company_name);
                return false;
            }
            })
            .autocomplete("instance")._renderItem = function (ul, item) {
                if (classContext.disabled) {  
                    $(ul).css({
                        "opacity": "0",
                        "visibility": "hidden"
                    });
                    return $("<li class='sl-symbol-list' style='display: none !important;'>").appendTo(ul);
                }

                $(ul).css({
                    "opacity": "",
                    "visibility": ""
                });

                const inputVal = $(`#${classContext.symbolInputElementId}`).val().toUpperCase();
                const symbolSpanTxt = item.symbol.replaceAll(inputVal, `<span class="sl-highlight-text">${inputVal}</span>`);
                var companySpanTxt = item.company_name ? item.company_name : "";
                var companySpanTxtWork = companySpanTxt;
                var idx = companySpanTxt ? companySpanTxt.toUpperCase().indexOf(inputVal) : -1;
                var countReplace = 0;
                while (idx >= 0) {
                    var origTxt = companySpanTxt.substring(idx, idx + inputVal.length);
                    var slicePos = idx + (countReplace * 39);  // maybe 39?
                    if (slicePos > companySpanTxtWork.length + inputVal.length - 1) {
                        break;
                    }
                    companySpanTxtWork = companySpanTxtWork.slice(0, slicePos) + `<span class="sl-highlight-text">${origTxt}</span>` + companySpanTxtWork.slice(slicePos + inputVal.length);
                    idx = companySpanTxt.toUpperCase().indexOf(inputVal, idx + 1);
                    countReplace++;
                }
                companySpanTxt = companySpanTxtWork;
                return $("<li class='sl-symbol-list'>")
                    .append(`<div><span class="sl-symbol-span">${symbolSpanTxt}</span><span class="sl-company-name-span">${(companySpanTxt ? companySpanTxt : '')}</span><span class="sl-exchange-span">${(item.exchange ? ' (' + item.exchange + ')' : '')}</span></div>`)
                    .appendTo(ul);
            };

        // Setup keyup event.
        $(`#${this.symbolInputElementId}`).on("keyup", function (event) {
            if (event.which == 13) {
                event.preventDefault();
                event.target.focus();
                event.target.select();
                classContext.disabled = true;
                $(event.target).autocomplete("close");
                $(event.target).autocomplete("disable");
                classContext.callbackFunction(event.target.value);
            } else if (event.which >= 16 && event.which <= 18) {
                classContext.disabled = true;
                $(event.target).autocomplete("close");
                $(event.target).autocomplete("disable");
            } else {
                classContext.disabled = false;
                $(event.target).autocomplete("enable");
            }
        });

        $(document).on("keydown", function (event) {
            if (event.which >= 16 && event.which <= 18) {
                classContext.disabled = true;
                $(`#${this.symbolInputElementId}`).autocomplete("close");
                $(`#${this.symbolInputElementId}`).autocomplete("disable");
            } else {
                classContext.disabled = false;
            }
        });

        // $(`#${this.symbolInputElementId}`).on("click",  (event) => {
        //     this.setSymbolFocus();
        // });

        // $(`#${this.symbolInputElementId}`).on("dblclick",  (event) => {
        //     this.setSymbolFocus();
        // });

        $(`#${this.symbolInputElementId}`).on("mousedown", (event) => {
            var symbolElement = document.getElementById(this.symbolInputElementId);
            symbolElement.select();
            if (document.activeElement == symbolElement) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }
        });

        if (this.setInitialFocus) {
            // Set focus to symbol input field.
            $(`#${this.symbolInputElementId}`).focus();
            $(`#${this.symbolInputElementId}`).select();
        }
    }

    // Add symbol to symbol list.
    addSymbolToList(symbol) {
        var symbolListElement = document.getElementById(this.symbolListElementId);
        if (symbolListElement != null) {
            if (this.useBSSymbolLookup) {
                const jsSetSymbol = `javascript:${this.objectName}.setSymbol("${symbol}")`;
                if (!symbolListElement.innerHTML.includes(`>${symbol}</a>`)) {
                    var menuItem = document.createElement("a");
                    menuItem.className = "dropdown-item";
                    menuItem.text = symbol;
                    menuItem.href = jsSetSymbol;
                    symbolListElement.appendChild(menuItem);
                }
            } else {
                if (!symbolListElement.querySelector('[value="' + symbol + '"]')) {
                    symbolListElement.add(new Option(symbol, symbol), 0);
                    symbolListElement.value = symbol;
                }
            }
        }
    }

    // Set focus to symbol.
    setSymbolFocus() {
        var symbolElement = document.getElementById(this.symbolInputElementId);
        if (symbolElement != null) {
            symbolElement.focus();
            symbolElement.select();
        }
    }
}